import { defineMessages } from "react-intl";

// The section's own name (title, sidebar entry, window title) is
// sectionNames.atticDigitalAssets in src/intl.ts.
export const sectionMessages = defineMessages({
  directorySaved: {
    id: "NN3y4T",
    defaultMessage: "Directory saved",
    description: "digital assets, notification",
  },
  directoryDeleted: {
    id: "j9d5iM",
    defaultMessage: "Directory deleted",
    description: "digital assets, notification",
  },
  fileDeleted: {
    id: "W6hCTx",
    defaultMessage: "File deleted",
    description: "digital assets, notification",
  },
  notFound: {
    id: "m4tP6b",
    defaultMessage: "This directory no longer exists.",
    description: "digital assets, directory page",
  },
  allDirectories: {
    id: "v20O0c",
    defaultMessage: "All directories",
    description:
      "digital assets directory page, TopNav destination link tooltip to the directory list",
  },
});

export const storeMessages = defineMessages({
  storage: {
    id: "iyMgEw",
    defaultMessage: "Storage",
    description: "digital assets list, usage label",
  },
  usage: {
    id: "uEajxT",
    defaultMessage: "{used} of {limit} used ({percent}%)",
    description: "digital assets list, usage value",
  },
  cdnOrigin: {
    id: "SULLNM",
    defaultMessage: "CDN origin",
    description: "digital assets list, label",
  },
  cdnUnknown: {
    id: "3/Ruso",
    defaultMessage: "Not known in this environment",
    description: "digital assets list, no CDN origin",
  },
});

export const directoryListMessages = defineMessages({
  addDirectory: {
    id: "DOM46a",
    defaultMessage: "Add directory",
    description: "digital assets list, button",
  },
  name: {
    id: "cwiGWq",
    defaultMessage: "Name",
    description: "digital assets list, column",
  },
  folder: {
    id: "PFTMgH",
    defaultMessage: "Folder",
    description: "digital assets list, column",
  },
  files: {
    id: "i1Yob+",
    defaultMessage: "Files",
    description: "digital assets list, column",
  },
  size: {
    id: "AwHE9N",
    defaultMessage: "Size",
    description: "digital assets list, column",
  },
  access: {
    id: "ZkhGix",
    defaultMessage: "Access",
    description: "digital assets list, column",
  },
  noDirectories: {
    id: "EZTMdj",
    defaultMessage: "No directories yet. Add one to start uploading files.",
    description: "digital assets list, empty state",
  },
  loadFailed: {
    id: "zfmmt5",
    defaultMessage: "Digital assets could not be loaded. Reload the page to try again.",
    description: "digital assets list, error state",
  },
  rename: {
    id: "3fQTQa",
    defaultMessage: "Rename",
    description: "digital assets list, row action",
  },
  delete: {
    id: "KMS3ns",
    defaultMessage: "Delete",
    description: "digital assets list, row action",
  },
  deleteRefusedDefault: {
    id: "Mp76ko",
    defaultMessage: "A default directory cannot be deleted.",
    description: "digital assets list, why the delete button is off",
  },
  deleteRefusedManaged: {
    id: "S55OGm",
    defaultMessage: "{name} manages this directory, so it cannot be deleted here.",
    description: "digital assets list, why the delete button is off; name is the app's",
  },
  deleteRefusedNotEmpty: {
    id: "wJuQgi",
    defaultMessage: "Only an empty directory can be deleted. Delete its files first.",
    description: "digital assets list, why the delete button is off",
  },
  deleteRefusedBusy: {
    id: "DItHna",
    defaultMessage: "This directory cannot be deleted right now (uploads may be in progress).",
    description: "digital assets list, why the delete button is off when no field explains it",
  },
  deleteLabel: {
    id: "DrYcjm",
    defaultMessage: "Delete {name}",
    description: "digital assets list, delete button's accessible name; name is the directory's",
  },
});

export const badgeMessages = defineMessages({
  default: {
    id: "7Y6UkF",
    defaultMessage: "Default",
    description: "digital assets directory badge",
  },
  managedByApp: {
    id: "Wz8qjh",
    defaultMessage: "Managed by app",
    description: "digital assets directory badge",
  },
  managedBy: {
    id: "Q/cx3N",
    defaultMessage: "Managed by {name}",
    description: "digital assets directory badge, with the app's name",
  },
  writable: {
    id: "Yaf8ba",
    defaultMessage: "Writable",
    description: "digital assets directory badge",
  },
  readOnly: {
    id: "EXWOQe",
    defaultMessage: "Read-only",
    description: "digital assets directory badge",
  },
});

export const directoryDialogMessages = defineMessages({
  createTitle: {
    id: "M0pLV8",
    defaultMessage: "Add directory",
    description: "digital assets, dialog title",
  },
  renameTitle: {
    id: "aeIQjY",
    defaultMessage: "Rename directory",
    description: "digital assets, dialog title",
  },
  name: {
    id: "Luf1Ar",
    defaultMessage: "Name",
    description: "digital assets dialog, field",
  },
  slug: {
    id: "shDqiR",
    defaultMessage: "Folder (optional)",
    description: "digital assets dialog, field",
  },
  slugHelp: {
    id: "1jwt/1",
    defaultMessage:
      "Lowercase letters, digits and hyphens; made from the name when left blank. It is part of every file URL and can never change.",
    description: "digital assets dialog, slug help",
  },
  renameHelp: {
    id: "MS2w46",
    defaultMessage: "The folder /{slug} and every URL under it stay the same.",
    description: "digital assets dialog, rename help",
  },
  create: {
    id: "m/wB2S",
    defaultMessage: "Add directory",
    description: "digital assets dialog, confirm button",
  },
  save: {
    id: "v3CLzX",
    defaultMessage: "Rename",
    description: "digital assets dialog, confirm button",
  },
  deleteTitle: {
    id: "MZfVTq",
    defaultMessage: "Delete directory",
    description: "digital assets, dialog title",
  },
  deleteContent: {
    id: "NgeezI",
    defaultMessage: "Delete {name}? The empty folder /{slug} is removed from the store.",
    description: "digital assets, delete dialog content",
  },
});

export const fileListMessages = defineMessages({
  searchPlaceholder: {
    id: "MFo5Hd",
    defaultMessage: "Search full file paths (every path starts with {slug}/)",
    description:
      "digital assets directory, search; the search matches the whole key, directory folder included",
  },
  preview: {
    id: "V7TpgE",
    defaultMessage: "Preview",
    description: "digital assets directory, column",
  },
  file: {
    id: "IZVEDB",
    defaultMessage: "File",
    description: "digital assets directory, column",
  },
  type: {
    id: "n1XYxr",
    defaultMessage: "Type",
    description: "digital assets directory, column",
  },
  size: {
    id: "KqXVlh",
    defaultMessage: "Size",
    description: "digital assets directory, column",
  },
  dimensions: {
    id: "unnZG3",
    defaultMessage: "Dimensions",
    description: "digital assets directory, column",
  },
  created: {
    id: "wLT6If",
    defaultMessage: "Created",
    description: "digital assets directory, column",
  },
  copyUrl: {
    id: "S8wLtz",
    defaultMessage: "Copy URL",
    description: "digital assets directory, row action",
  },
  copyUrlLabel: {
    id: "uwbLv6",
    defaultMessage: "Copy URL of {filename}",
    description: "digital assets directory, copy button's accessible name",
  },
  deleteLabel: {
    id: "QBTVDI",
    defaultMessage: "Delete {filename}",
    description: "digital assets directory, delete button's accessible name",
  },
  copied: {
    id: "bqhQ3g",
    defaultMessage: "Copied",
    description: "digital assets directory, row action after copying",
  },
  delete: {
    id: "FFWqDH",
    defaultMessage: "Delete",
    description: "digital assets directory, row action",
  },
  noFiles: {
    id: "o/WPtj",
    defaultMessage: "No files in this directory yet.",
    description: "digital assets directory, empty state",
  },
  noMatches: {
    id: "Z6aMg0",
    defaultMessage: "No files match this search.",
    description: "digital assets directory, empty search",
  },
  fileCount: {
    id: "9KJueP",
    defaultMessage: "{count, plural, one {# file} other {# files}} · {size}",
    description: "digital assets directory, subtitle",
  },
  readOnlyTitle: {
    id: "4tqrrN",
    defaultMessage: "Read-only directory",
    description: "digital assets directory, banner title",
  },
  readOnlyBody: {
    id: "TFFC66",
    defaultMessage:
      "Managed by {manager}. You can browse its files and copy their URLs; changes are made in the app.",
    description: "digital assets directory, banner body",
  },
  anApp: {
    id: "iI5NeC",
    defaultMessage: "an app",
    description: "digital assets directory, banner: the manager when no app is named",
  },
  copyFailed: {
    defaultMessage: "The URL could not be copied (the browser refused the clipboard): {url}",
    id: "2QdJZ1",
    description: "digital assets directory, copy URL failed notification",
  },
  loadFailed: {
    defaultMessage: "Files could not be loaded. Reload the page to try again.",
    id: "I/DLNZ",
    description: "digital assets directory, file list error state",
  },
  deleteTitle: {
    id: "hpykul",
    defaultMessage: "Delete file",
    description: "digital assets, dialog title",
  },
  deleteContent: {
    id: "9id1lp",
    defaultMessage:
      "Delete {filename}? Its URL stops working everywhere it is used, CDN copies included.",
    description: "digital assets, delete file dialog content",
  },
});

export const uploadMessages = defineMessages({
  title: {
    id: "8zNow8",
    defaultMessage: "Upload files",
    description: "digital assets upload card, title",
  },
  subpath: {
    id: "tqCjOm",
    defaultMessage: "Folder inside this directory (optional)",
    description: "digital assets upload card, field",
  },
  subpathHelp: {
    id: "OL7eTK",
    defaultMessage: "For example builds/2019. Files land at the directory's root when left blank.",
    description: "digital assets upload card, field help",
  },
  dropHint: {
    id: "qd8A/3",
    defaultMessage: "Drop files here, or click to choose",
    description: "digital assets upload card, dropzone",
  },
  limits: {
    id: "kqpDbg",
    defaultMessage:
      "Up to {max} per file. JPEG, PNG, WebP, GIF, AVIF, SVG, ICO, PDF, MP4, WOFF and WOFF2. A name already in use is refused: a replacement needs a new name.",
    description: "digital assets upload card, limits",
  },
  queued: {
    id: "aRR3qE",
    defaultMessage: "Waiting",
    description: "digital assets upload status",
  },
  create: {
    id: "SAinjw",
    defaultMessage: "Preparing",
    description: "digital assets upload status",
  },
  put: {
    id: "rSCTAw",
    defaultMessage: "Uploading",
    description: "digital assets upload status",
  },
  confirm: {
    id: "nrLBJm",
    defaultMessage: "Checking",
    description: "digital assets upload status",
  },
  done: {
    id: "/xfBjt",
    defaultMessage: "Uploaded",
    description: "digital assets upload status",
  },
  failed: {
    id: "07BvEO",
    defaultMessage: "Failed",
    description: "digital assets upload status",
  },
  cancelled: {
    defaultMessage: "Cancelled",
    id: "rWSq21",
    description: "digital assets upload status",
  },
  progress: {
    defaultMessage: "Uploading {percent}%",
    id: "Q/D64t",
    description: "digital assets upload status with the share sent",
  },
  cancel: {
    defaultMessage: "Cancel",
    id: "LaL22r",
    description: "digital assets upload row, button",
  },
  cancelLabel: {
    defaultMessage: "Cancel upload of {path}",
    id: "Wf/YTz",
    description: "digital assets upload row, cancel button's accessible name",
  },
  statusSummary: {
    defaultMessage:
      "Uploads: {active} in progress, {done} uploaded, {failed} failed, {cancelled} cancelled",
    id: "jPqoIY",
    description: "digital assets upload card, screen reader announcement of the queue's state",
  },
  nothingToUpload: {
    defaultMessage:
      "Nothing to upload: {ignored, plural, =0 {the drop held no files (hidden and system files such as .DS_Store are skipped)} one {the drop held only a hidden or system file} other {the drop held only hidden or system files (such as .DS_Store)}}.",
    id: "m1qUZ7",
    description: "digital assets upload card, a drop with no file to upload",
  },
  ignoredSkipped: {
    defaultMessage:
      "{ignored, plural, one {# hidden or system file was} other {# hidden or system files were}} skipped.",
    id: "hQY5a3",
    description: "digital assets upload card, dotfiles left out of a drop",
  },
  sessionExpired: {
    defaultMessage: "Not uploaded: the session expired. Sign in again, then upload it again.",
    id: "h6EU0M",
    description: "digital assets upload error",
  },
  readOnly: {
    defaultMessage: "Not uploaded: the store is in read-only mode.",
    id: "J5FveD",
    description: "digital assets upload error",
  },
  sessionExpiredAfterUpload: {
    defaultMessage:
      "The file was uploaded but not confirmed: the session expired. Sign in again and refresh the page to check whether it is listed.",
    id: "y1ey2O",
    description:
      "digital assets upload error: the bytes landed, then confirm met an expired session",
  },
  readOnlyAfterUpload: {
    defaultMessage:
      "The file was uploaded but not confirmed: the store is in read-only mode. Refresh the page later to check whether it is listed.",
    id: "bgRxtu",
    description: "digital assets upload error: the bytes landed, then confirm met read-only mode",
  },
  nameHeld: {
    defaultMessage:
      "If it is not listed, this name stays reserved until the store clears the unfinished upload (within the hour); the file can be uploaded under another name now.",
    id: "sG55uQ",
    description:
      "digital assets upload error, second sentence after a file was uploaded but not confirmed: the backend holds the name until the pending upload expires (an hour by default)",
  },
  withNameHeld: {
    defaultMessage: "{what} {nameHeld}",
    id: "sTEVTO",
    description: "digital assets upload error: what happened, then the nameHeld sentence",
  },
  duplicateInQueue: {
    defaultMessage:
      "Not uploaded: another file in the queue goes to the same name. Rename this file, or drop it again once the other has finished.",
    id: "0+feJU",
    description: "digital assets upload error: two files in the queue would get the same key",
  },
  refusedFolderName: {
    defaultMessage:
      'Not uploaded: the folder name "{folder}" has nothing that can be used in a file path. Rename the folder and drop it again.',
    id: "v+lNgJ",
    description: "digital assets upload error: a dropped folder whose name cleans to nothing",
  },
  leaveNotice: {
    defaultMessage: "Leaving this page cancels the uploads in progress.",
    id: "Qqu21b",
    description: "digital assets upload card, shown while uploads run",
  },
  outcomeUnknown: {
    defaultMessage:
      "The file was sent, but whether it went live is not known. Refresh the page to check before uploading it again.",
    id: "Vn4BLT",
    description: "digital assets upload error, a lost confirm answer followed by a refused retry",
  },
  clearFinished: {
    id: "G1+pwV",
    defaultMessage: "Clear finished",
    description: "digital assets upload card, button",
  },
  refusedType: {
    id: "cvPbXB",
    defaultMessage: "This file type is not accepted.",
    description: "digital assets upload error",
  },
  refusedEmpty: {
    id: "v66jcJ",
    defaultMessage: "The file is empty.",
    description: "digital assets upload error",
  },
  refusedTooLarge: {
    id: "hItjhV",
    defaultMessage: "Larger than the {max} limit per file.",
    description: "digital assets upload error",
  },
  refusedFolder: {
    defaultMessage:
      "Folder names may use letters, digits, dots, hyphens and underscores, and must start with a letter or digit.",
    id: "+Kywdr",
    description: "digital assets upload error and folder field error",
  },
  stalled: {
    defaultMessage:
      "Storage stopped responding, so the upload was stopped. Try again in a few minutes.",
    id: "QnFkZ8",
    description:
      "digital assets upload error; the backend keeps the name reserved for a few minutes after a PUT that did not land",
  },
  unconfirmed: {
    defaultMessage:
      "The file was uploaded but could not be confirmed. Refresh the page to check whether it is listed.",
    id: "4KtJoV",
    description: "digital assets upload error: the bytes landed, no confirm went through",
  },
  createUnanswered: {
    defaultMessage:
      "The upload could not be started: no answer came back. If this name is then refused as being uploaded, wait a few minutes or use another name.",
    id: "Kzxa7D",
    description:
      "digital assets upload error: create got no answer, so the backend may hold the name until its signed URL lapses (a few minutes)",
  },
  createFailed: {
    id: "FmuCp8",
    defaultMessage: "The upload could not be started. Check the connection and try again.",
    description: "digital assets upload error",
  },
  putRefused: {
    id: "uOWVpF",
    defaultMessage: "Storage did not accept the file (HTTP {status}). Try again in a few minutes.",
    description:
      "digital assets upload error; the backend keeps the name reserved for a few minutes after a PUT that did not land",
  },
  putFailed: {
    id: "L9goJd",
    defaultMessage:
      "The file could not be sent to storage. Check the connection and try again in a few minutes.",
    description:
      "digital assets upload error; the backend keeps the name reserved for a few minutes after a PUT that did not land",
  },
  confirmFailed: {
    id: "/lgFME",
    defaultMessage: "The file was sent but could not be checked. Try again.",
    description: "digital assets upload error",
  },
});
